import React from 'react';
import DOMPurify from 'dompurify';
import SocialVideoEmbed from './SocialVideoEmbed';

// Matches the marker divs RichTextEditor's VideoEmbed node writes out —
// <div data-video-embed="URL">...</div> — non-greedy and tolerant of
// attribute-order/whitespace variation from ProseMirror's serializer.
const VIDEO_MARKER_RE = /<div[^>]*\bdata-video-embed="([^"]*)"[^>]*>[\s\S]*?<\/div>/g;

// Renders admin/editor-authored rich HTML (from RichTextEditor) safely.
// Two concerns, handled separately: (1) this HTML round-trips through the
// API, so it's sanitized here — right before it reaches a visitor's
// browser — regardless of how it got into the database; (2) inline videos
// are stored as inert marker divs (never a live iframe in the DB), swapped
// for a real SocialVideoEmbed only at render time, which is what keeps a
// "paste a URL" video at zero server storage cost.
export default function RichContent({ html, className = '' }) {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html);

  const parts = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  VIDEO_MARKER_RE.lastIndex = 0;
  while ((match = VIDEO_MARKER_RE.exec(clean)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'html', key: key++, html: clean.slice(lastIndex, match.index) });
    }
    parts.push({ type: 'video', key: key++, url: match[1] });
    lastIndex = VIDEO_MARKER_RE.lastIndex;
  }
  if (lastIndex < clean.length) {
    parts.push({ type: 'html', key: key++, html: clean.slice(lastIndex) });
  }

  return (
    <div className={className}>
      {parts.map(part => part.type === 'video'
        ? <SocialVideoEmbed key={part.key} url={part.url} className="my-6" />
        : <div key={part.key} className="tiptap-content" dangerouslySetInnerHTML={{ __html: part.html }} />
      )}
    </div>
  );
}
